const DEFAULT_MARKETING_URL = 'https://developmentexpress.in';

export function getMarketingSiteUrl() {
  const fromEnv = process.env.REACT_APP_MARKETING_SITE_URL?.trim();
  return fromEnv || DEFAULT_MARKETING_URL;
}

function isInAppHost(hostname) {
  const host = String(hostname || '').toLowerCase();
  return (
    host === 'localhost' ||
    host.includes('127.0.0.1') ||
    host.includes('app.') ||
    host.includes('developmentexpress') ||
    host.includes('vercel.app')
  );
}

function isExternalMarketingReferrer(referrer) {
  try {
    const host = new URL(referrer).hostname.toLowerCase();
    if (isInAppHost(host)) return false;
    return true;
  } catch {
    return false;
  }
}

/** Leave Development Express app and return to the public marketing website. */
export function exitToMarketingSite() {
  const marketingUrl = getMarketingSiteUrl();
  const referrer = document.referrer;

  if (referrer && isExternalMarketingReferrer(referrer)) {
    window.location.assign(referrer);
    return;
  }

  window.location.assign(marketingUrl);
}
